import { Injectable, DestroyRef, inject } from "@angular/core";
import { Address, Building, BuildingInfo, Customer } from "@app/core/stingray-api/models";
import { BuildingInfoService } from "@app/core/stingray-api/services";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import _ from "lodash";
import { Observable } from "rxjs";
import { EditBuildingPanelModel } from "../edit-building-panel/edit-building-panel-model";
import { EditBuildingPanelOptions } from "../edit-building-panel/edit-building-panel-options";
import { AddressRow } from "./address-row";
import { TranslateService } from "@ngx-translate/core";


@Injectable()
export class AddressRowFactory {

  private destroyRef = inject(DestroyRef);
  constructor(
    private buildingInfoService: BuildingInfoService,
    private translateService: TranslateService) { }

    public createAddressRow(customerId: string, address: Address, selected: boolean, isUnlinkedCombination: boolean, existingBuilding: Building, mortgageIds: string[], options: Partial<EditBuildingPanelOptions>, includeValue: boolean, includeEnergy: boolean, owned?: boolean): Observable<AddressRow> {
        return new Observable(obs => {
    
          this.buildingInfoService.getBuildingInfo(
            {
              postalCode: address.postalCode,
              houseNumber: parseInt(address.houseNumber, 10),
              houseNumberAddition: address.houseNumberAddition,
              includeRegistration: true,
              includeValue: includeValue,
              includeEnergy: includeEnergy
            })
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((info: BuildingInfo) => {
    
              let name = `${address.addressLine1}, ${address.city}`;
              let additionalAddresses: Address[] = [];
    
              /* Check if it's a multi-tenant building */
              if (info && info.registration && info.registration.addresses.length > 1 && isUnlinkedCombination === false) {
                const streets = _.groupBy(info.registration.addresses, x => x.street);
                name = `${Object.keys(streets)[0]} ${this.translateService.instant('multi-tenant building')}`;
                additionalAddresses = info.registration.addresses;
              }
    
              const modelBuilding = existingBuilding ?? {
                address: address,
                constructionYear: info?.registration?.constructionYear,
                energyIndex: null,
                energyPerformanceRegistrationDate: info?.energy?.registrationDate,
                estimatedValueByMunicipality: info?.value?.value,
                estimatedValueByMunicipalityDate: info?.value?.startDate,
                finalEnergyLabel: info?.energy?.energyLabel,
                status: owned === null ? null : (owned ? 'Owned' : 'Purchase'),
                surface: info?.registration?.surface,
                type: info?.registration?.type
              } as Building;
    
              const editBuildingModel = { 
                customerId: customerId, 
                name, 
                address, 
                additionalAddresses, 
                building: modelBuilding,
                mortgageIds 
              } as EditBuildingPanelModel;
              
              const addressRow = { 
                name, 
                editBuildingModel, 
                selected, 
                options,
                address, 
                additionalAddresses, 
                owned,
                unlinked: isUnlinkedCombination,
              } as AddressRow;  
              
              obs.next(addressRow);
              obs.complete();
            });    
        })
      }
}
